export const getPriceRural = async () => {
  const { data } = await fetchPriceRural();
  return data ? data : null;
};

const fetchPriceRural = async () => {
  try {
    const response = await fetch(
      `${process.env.API_RURAL}/api/rural/flashcotizaciones`
    );
    const data = await response.json();
    return {
      code: 200,
      data: data.item ?? {},
      error: null,
    };
  } catch (error) {
    return false;
  }
};
